module.exports = __webpack_public_path__ + "6524ee8e4b4ab17a5a9d46988c4a91b7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/mummy-hand.png
// module id = 2409
// module chunks = 0